// extracted by mini-css-extract-plugin
export default {"actionsCell":"GbgPRvS3NhTUMV3aOO8P"};